// Mobile only (iOS Safari compatible)
if (window.matchMedia('(max-width: 1024px)').matches) {
  document.addEventListener('click', function (e) {
    const link = e.target.closest('a.product-card__media');
    if (!link) return;

    const figure = link.closest('.product-card__figure');
    if (!figure) return;

    const primaryImg = figure.querySelector('.product-card__image--primary');
    const secondaryImg = figure.querySelector('.product-card__image--secondary');

    if (!primaryImg || !secondaryImg) return;

    // Use attribute instead of dataset (Safari-safe)
    const toggled = figure.getAttribute('data-toggled') === '1';

    if (!toggled) {
      e.preventDefault(); // Required for iOS Safari

      // Force layout before opacity change (Safari quirk fix)
      primaryImg.offsetHeight;

      primaryImg.style.opacity = '0';
      secondaryImg.style.opacity = '1';
      figure.setAttribute('data-toggled', '1');

      const resetListener = function (event) {
        if (!figure.contains(event.target)) {
          primaryImg.style.opacity = '1';
          secondaryImg.style.opacity = '0';
          figure.removeAttribute('data-toggled');
          document.removeEventListener('click', resetListener);
        }
      };

      // Delay binding to avoid immediate self-trigger on iOS
      setTimeout(function () {
        document.addEventListener('click', resetListener);
      }, 0);
    }
    // Second tap → normal navigation
  });
}
